// 도메인 리다이렉트 설정
export const redirectConfig = {
  enabled: true, // 리다이렉트 활성화 여부
  debug: true, // 디버그 모드 (콘솔에 로그 출력)
  rules: [
    {
      // 리다이렉트할 대상 도메인+포트
      targetDomain: process.env.VUE_APP_REDIRECT_TARGET_URL,
      redirectUrl: process.env.VUE_APP_REDIRECT_URL,
      conditions: {
        // 특정 경로에서만 리다이렉트
        pathPattern: null, // null이면 모든 경로에서 리다이렉트
      },
    },
  ],
};

/** [리다이렉트] 특정 도메인/포트로 접속 시 리다이렉트 : 바로바 > 발주입고 경로로 리다이렉트 */
export const checkAndRedirect = () => {
  if (!redirectConfig.enabled) return;

  const currentHost = window.location.host;
  const currentPath = window.location.pathname;

  for (const rule of redirectConfig.rules) {
    if (currentHost === rule.targetDomain) {
      // 경로 패턴 체크
      if (rule.conditions.pathPattern) {
        const pathRegex = new RegExp(rule.conditions.pathPattern);
        if (!pathRegex.test(currentPath)) {
          continue; // 경로가 일치하지 않으면 다음 규칙 확인
        }
      }

      // 리다이렉트 실행
      if (redirectConfig.debug) {
        console.log(
          `도메인 리다이렉트 실행: ${currentHost} -> ${rule.redirectUrl}`
        );
      }

      window.location.href = rule.redirectUrl;
      return; // 첫 번째 일치하는 규칙에서 리다이렉트 후 종료
    }
  }

  if (redirectConfig.debug) {
    console.log(`도메인 리다이렉트 조건 불일치: ${currentHost}`);
  }
};
